import { Icon } from "components";
import { PLUS } from "icons";
import { useNavigate } from "react-router-dom";

export default function BookmarkDisplayCard({
    projectLogo,
    projectTitle,
    projectId,
    bookmarkCount,
    links,
    // onAddNewClick, 
    gradientColors = null
}) {
    const navigate = useNavigate();
    return (
        <div className="w-full overflow-hidden">

            <div className="bg-[#F4F4F5] rounded-xl">
                {/* Header */}
                <div className="flex items-center gap-3 p-4">
                    {/* Project Logo/Icon */}
                    <div className="w-9 h-9 rounded-sm flex-shrink-0 overflow-hidden cursor-pointer" onClick={() => navigate(`/work/projects/${projectId}`)}>
                        {projectLogo ? (
                            <img
                                src={`${import.meta.env?.VITE_BASE_URL}/assets/${projectLogo}`}
                                alt={`${projectTitle} logo`}
                                className="w-full h-full object-cover"
                            />
                        ) : gradientColors ? (
                            // Custom gradient background (like Everest mountain design)
                            <div
                                className="w-full h-full flex items-center justify-center relative"
                                style={{
                                    background: `linear-gradient(135deg, ${gradientColors.from} 0%, ${gradientColors.to} 100%)`
                                }}
                            >
                                {/* Mountain-like shapes for Everest design */}
                                {projectTitle.toLowerCase() === 'everest' && (
                                    <>
                                        <div className="absolute bottom-0 left-0 w-0 h-0 border-l-6 border-r-6 border-b-8 border-l-transparent border-r-transparent border-b-pink-300 opacity-60"></div>
                                        <div className="absolute bottom-0 right-1 w-0 h-0 border-l-5 border-r-5 border-b-6 border-l-transparent border-r-transparent border-b-red-400"></div>
                                    </>
                                )}
                            </div>
                        ) : (
                            // Default letter avatar
                            <div className="w-full h-full bg-gray-100 flex items-center justify-center rounded-xl">
                                <span className="text-gray-600 text-lg font-semibold">
                                    {projectTitle[0]?.toUpperCase()}
                                </span>
                            </div>
                        )}
                    </div>

                    {/* Project Info */}
                    <div className="flex-1 min-w-0">
                        <div className="font-semibold text-gray-900 text-xl truncate leading-none cursor-pointer" onClick={() => navigate(`/work/projects/${projectId}`)}>
                            {projectTitle}
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 leading-none">
                            {bookmarkCount} {bookmarkCount === 1 ? "bookmark" : "bookmarks"}
                        </p>
                    </div>
                </div>
                {/* Links List */}
                <div className="py-2 border bg-white rounded-xl border-gray-200 shadow-sm">
                    {links.map((link) => {
                        let domain;
                        try {
                            domain = new URL(link.url).hostname;
                        } catch {
                            domain = null;
                        }

                        return (
                            <a
                                key={link.id}
                                target="_blank"
                                href={link.url || "#"}
                                className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors duration-150 group"
                            >
                                {/* Favicon */}
                                <div className="w-4 h-4 flex-shrink-0 flex items-center justify-center">
                                    <img
                                        src={domain ? `https://www.google.com/s2/favicons?domain=${domain}&sz=32` : ''}
                                        alt=""
                                        className="w-4 h-4 object-contain rounded-sm"
                                        onError={(e) => {
                                            // Create a colored square with first letter as fallback
                                            const canvas = document.createElement('canvas');
                                            canvas.width = 16;
                                            canvas.height = 16;
                                            const ctx = canvas.getContext('2d');

                                            // Generate a color based on the first letter
                                            const firstLetter = (link.label || domain || 'L')[0].toUpperCase();
                                            const colors = ['#6366f1', '#8b5cf6', '#06b6d4', '#10b981', '#f59e0b', '#ef4444'];
                                            const colorIndex = firstLetter.charCodeAt(0) % colors.length;

                                            ctx.fillStyle = colors[colorIndex];
                                            ctx.fillRect(0, 0, 16, 16);

                                            ctx.fillStyle = 'white';
                                            ctx.font = '10px system-ui';
                                            ctx.textAlign = 'center';
                                            ctx.textBaseline = 'middle';
                                            ctx.fillText(firstLetter, 8, 8);

                                            e.currentTarget.src = canvas.toDataURL();
                                        }}
                                        onLoad={(e) => {
                                            // If the favicon fails to load (1x1 transparent pixel), create fallback
                                            if (e.currentTarget.naturalWidth === 1 && e.currentTarget.naturalHeight === 1) {
                                                e.currentTarget.onerror(e);
                                            }
                                        }}
                                    />
                                </div>

                                {/* Link Label */}
                                <span className="text-gray-700 text-sm font-medium flex-1 truncate group-hover:text-gray-900">
                                    {link.label}
                                </span>
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}